// extracted by mini-css-extract-plugin
export default {"shakaPlayer":"ShakaPlayer_shakaPlayer__1+sdW"};